module.exports = __webpack_public_path__ + "img/hr-level3addon_dead_mask.a0951a61.png";